export default {
  namespace: true,
  state: {
    loading: false,
    locais_atendimento: [],
    payload_local_atendimento: {
      name: '',
      street: '',
      number: '',
      district: '',
      status: true,
      uf: '',
      zipCode: '',
      specialistId: null,
      latitude: '-23.5588874',
      city: '',
      longitude: '-46.6589067',
    },
  },
  mutations: {

    SET_LOCAL_ATENDIMENTO(state, payload) {
      state.locais_atendimento = payload.places_specialists
      const objetoFixo = {
        id: 0,
        name: 'Atendimento Online',
        street: '-',
        number: '-',
        district: '-',
        status: payload.use_online,
        ufId: 5,
        zipCode: '-',
        city: {
          id: 5,
          name: '-',
          uf: '-',
        },
      }
      state.locais_atendimento.unshift(objetoFixo)
    },

    SET_PAYLOAD_LOCAL_ATENDIMENTO(state, payload) {
      state.payload_local_atendimento = payload
    },

    CLEAR_PAYLOAD_LOCAL_ATENDIMENTO(state) {
      state.payload_local_atendimento = {
        name: '',
        street: '',
        number: '',
        district: '',
        status: true,
        uf: '',
        zipCode: '',
        city: '',
      }
    },

  },
  actions: {

  },
  getters: {
    loading: state => state.loading,
    locais_atendimento: state => state.locais_atendimento,
    payload_local_atendimento: state => state.payload_local_atendimento,
  },
}
